import {
  ApiCancellationPreviewResp,
  CancellationReq,
  CancellationResp,
  CancellationPreviewResp,
  CancelledObjectType,
  CancelGroupOrderObjectReq,
  CustomerCancelledSubOrdersResp,
} from '@types'

interface GetCancelPreviewCoordinator {
  RestService: {
    get: (
      path: string,
      params: CancellationReq,
    ) => Promise<ApiCancellationPreviewResp>
  }
  HandleError: any
  pResponseCancellationPreview: (
    resp: ApiCancellationPreviewResp,
  ) => CancellationPreviewResp
}
export const GetCancelPreview =
  ({
    RestService,
    HandleError,
    pResponseCancellationPreview,
  }: GetCancelPreviewCoordinator) =>
  async (
    grpId: string,
    req: CancellationReq,
  ): Promise<CancellationPreviewResp | null> => {
    try {
      const resp = await RestService.get(
        `/group-orders/${grpId}/cancel-preview`,
        req,
      )

      return pResponseCancellationPreview(resp)
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

interface GetCancelledSubOrdersCoordinator {
  RestService: {
    post: (
      path: string,
      params: {
        cancelledObjectId: string
        cancelledObjectType: CancelledObjectType
      },
    ) => Promise<CustomerCancelledSubOrdersResp[]>
  }
  HandleError: any
}
export const GetCancelledSubOrders =
  ({ RestService, HandleError }: GetCancelledSubOrdersCoordinator) =>
  async (
    grpId: string,
    req: {
      cancelledObjectId: string
      cancelledObjectType: CancelledObjectType
    },
  ): Promise<CustomerCancelledSubOrdersResp[] | null> => {
    try {
      const resp = await RestService.post(
        `/group-orders/${grpId}/cancelled-sub-orders`,
        req,
      )

      return resp
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

interface CancelGroupOrderObjectCoordinator {
  RestService: {
    post: (
      path: string,
      body: CancelGroupOrderObjectReq,
      opts: { timeout: number },
    ) => Promise<CancellationResp | null>
  }
  HandleError: any
}
export const CancelGroupOrderObject =
  ({ RestService, HandleError }: CancelGroupOrderObjectCoordinator) =>
  async (
    grpId: string,
    req: CancelGroupOrderObjectReq,
  ): Promise<CancellationResp | null> => {
    try {
      const resp = await RestService.post(
        `/group-orders/${grpId}/cancel-object`,
        req,
        { timeout: 2 * 60 * 1000 },
      )

      return resp
    } catch (error) {
      HandleError({ error })

      return null
    }
  }
